module.exports = __webpack_public_path__ + "6c4a0dbc/img/search-filter-icon.c4751a52.svg";